export default __webpack_public_path__ + "static/media/Rectangle2.dac94c1e.png";